module.exports = __webpack_public_path__ + "static/media/Jawbreak-Serif.5e5b55ef.ttf";